import { getActivities } from 'actions/activity';
import { getBanner } from 'actions/banner';
import { getPopups } from 'actions/popup';
import { getHotelMeta } from 'actions/hotel';

export default store => ({
	path: 'activities',
	indexRoute: {
		getComponent: (nextState, cb) =>
			require.ensure(
				[],
				require => {
					const component = require('./Home').default;
					cb(null, component);
				},
				'Activity',
			),
		onEnter: ({ params: { lang, hotel } }) => {
			store.dispatch(getActivities(lang, hotel));
			store.dispatch(getBanner(lang, hotel, 'activity'));
			store.dispatch(getPopups(lang, hotel));
			store.dispatch(getHotelMeta(lang, hotel, 'activities'));
		},
	},
});



// WEBPACK FOOTER //
// ./src/routes/Hotel/Activity/index.js